module.exports = __webpack_public_path__ + "static/media/Tick.a42470bc.png";